export default {
  custom_option: 'Eget beløb',
  zero_option: 'Ingen drikkepenge',
};
